import { render, staticRenderFns } from "./EnviromentalStudy.vue?vue&type=template&id=132c51e9&scoped=true&"
import script from "./EnviromentalStudy.vue?vue&type=script&lang=js&"
export * from "./EnviromentalStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c51e9",
  null
  
)

export default component.exports